<template>
    <div
        v-b-tooltip.hover
        class="report-button"
        title="Report"
        @mouseenter="toggleDialog"
        @mouseleave="toggleDialog"
    >
        <button type="button" class="toggle-btn" @click="toggleDialog">
            <report-icon />
        </button>

        <div class="report-dialog" :class="{ opened: showDialog }">
            <button v-for="report in reports" :key="report.title">
                <router-link
                    :to="{ name: report.routeName, params: $route.params }"
                    target="_blank"
                >
                    {{ report.title }}
                </router-link>
            </button>
        </div>
    </div>
</template>

<script>
import { ROUTES } from '../../../business/const'
import ReportIcon from '../partials/icons/ReportIcon'

export default {
    name: 'ReportButton',
    components: { ReportIcon },
    data: () => ({
        ROUTES,
        showDialog: false,
        reports: [
            {
                title: 'Cycle Report',
                routeName: ROUTES.CYCLE_REPORT
            },
            {
                title: 'Fert Report',
                routeName: ROUTES.FERT_REPORT
            }
        ]
    }),
    methods: {
        toggleDialog() {
            this.showDialog = !this.showDialog
        }
    }
}
</script>

<style lang="scss" scoped>
.report-button {
    --f-desaturated-cyan: #6c9d9d;
    --f-viridian-green: #109898;
    --f-dark-charcoal: #2d2d34;

    position: relative;

    button {
        background: none;
        color: inherit;
        border: none;
    }
    a {
        color: inherit;
        text-decoration: inherit;
    }

    .toggle-btn {
        height: 100%;
        width: 100%;
        padding: 12px;
    }

    .report-dialog {
        &.opened {
            position: absolute;
            right: 0;
            display: flex;
            flex-direction: column;

            button {
                padding: 10px 20px;
                background-color: var(--f-desaturated-cyan);

                &:hover,
                &:active {
                    background-color: var(--f-viridian-green);
                }

                &:first-child {
                    border-bottom: solid 1px var(--f-dark-charcoal);
                }
            }
        }
        &:not(.opened) {
            display: none;
        }
    }
}
</style>
